














































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import Alert from '@/components/Alert.vue';
import { State, Action, Getter, Mutation } from 'vuex-class';
import { IMessage } from '@/store/alert/types';
import { AdminSiteState, AdminSite } from '@/store/adminsite/types';
import { Smart } from '@/store/smart/types';
import Cards from '@/components/Cards.vue';
import ChannelHelper from '../helpers/ChannelHelper';
import session from '@/session';

const namespace: string = 'adminsite';

@Component({
  components: {
    Cards,
    Alert,
  },
})
export default class Region extends Vue {
  @Mutation('alert/SHOW') private alert: (alertMessage: IMessage) => void;
  @State('adminsite') private adminSiteState: any;
  @Action('getOne', { namespace }) private getOne: (_id: string) => void;
  @Action('onSmart', { namespace: 'smart' }) private onSmart: (
    connect: any,
  ) => void;
  @Action('syncSmart', { namespace: 'smart' }) private syncSmart: (
    id: string,
  ) => Promise<undefined>;
  @Action('getSmart', { namespace }) private getSmart: (
    smartConnect: any,
  ) => void;
  @Prop(String) private _idRegion: string;
  @Prop(String) private _idSite: string;

  private interval: number;

  public mounted() {
    this.adminSiteState.dataAdminSite = [];
    let payload = {
      _idRegion: this._idRegion,
      _idSite: this._idSite,
    };
    this.getSmart(payload);

    // Auto refresh every 30s
    this.interval = setInterval(() => {
      this.getSmart(payload);
    }, 30000);
  }

  // Cancel auto refresh every 30s
  public beforeDestroy() {
    clearInterval(this.interval);
  }

  public filter(value: any) {
    return value
      .filter(
        (v: any) =>
          v.no === 1 ||
          v.no === 2 ||
          (v.no === 3 && v.active !== 'false') ||
          (v.no === 4 && v.active !== 'false') ||
          v.no === 7 ||
          v.no === 8,
        // Hide outputs
        // || v.no === 9 || v.no === 10,
      )
      .sort(function(a: any, b: any) {
        let indexA = a.no;
        let indexB = b.no;
        if (indexA == 3 || indexA == 4) indexA = indexA - 6;
        if (indexB == 3 || indexB == 4) indexB = indexB - 6;
        return indexA - indexB;
      });
  }

  public getCloudy(s: any) {
    let cloudy = '';
    s.channels.forEach((ch: any) => {
      if (ch !== undefined && ch.no === 11) {
        if (ch.lastValue !== undefined) {
          if (ch.city !== undefined && ch.city !== '') {
            cloudy =
              'Nébulosité : ' +
              ch.lastValue.v +
              '%  à ' +
              ch.city +
              ' (' +
              this.dateConvert(ch.lastValue.t) +
              ')';
          } else {
            cloudy =
              'Nébulosité : ' +
              ch.lastValue.v +
              '% (' +
              this.dateConvert(ch.lastValue.t) +
              ')';
          }
        }
      }
    });
    return cloudy;
  }

  public getBackGroundClass(ch: any) {
    if (ChannelHelper.getChannelInAlarm(ch) == 'ERROR') return 'red';
    else if (ChannelHelper.getChannelInAlarm(ch) == 'WARNING') return 'yellow';
    else return 'blue';
  }

  public getBackGroundClassForSmart(s: any) {
    if (s.channels === undefined || s.channels.length === 0) return 'green';
    let inAlarm = false;
    let inWarning = false;
    s.channels.forEach((ch: any) => {
      if (ChannelHelper.getChannelInAlarm(ch) == 'ERROR') inAlarm = true;
      if (ChannelHelper.getChannelInAlarm(ch) == 'WARNING') inWarning = true;
    });
    if (inAlarm) return 'red';
    if (inWarning) return 'yellow';
    return 'green';
  }

  public dateConvert(date: any) {
    let d = new Date(date);
    let datePicker = '';
    datePicker =
      (d.getDate() < 10 ? '0' : '') +
      d.getDate() +
      '/' +
      (d.getMonth() < 9 ? '0' : '') +
      (d.getMonth() + 1) +
      '/' +
      d.getFullYear() +
      ' , ' +
      d.getHours() +
      ':' +
      (d.getMinutes() < 10 ? '0' : '') +
      d.getMinutes() +
      ':' +
      (d.getSeconds() < 10 ? '0' : '') +
      d.getSeconds();
    return datePicker;
  }

  public logoChoice(value: any) {
    let logo = '';
    if (
      value.no === 1 ||
      value.no === 2 ||
      value.no === 3 ||
      value.no === 4
      // value.no === 7 ||
      // value.no === 8
    ) {
      logo = 'home_thermometer';
    } else if (value.no === 7 || value.no === 8) {
      if (value.lastValue && value.lastValue.v === 1) {
        logo = 'electric_switch';
      } else if (value.lastValue && value.lastValue.v === 0) {
        logo = 'electric_switch_closed';
      } else {
        logo = 'face';
      }
    }
    return logo;
  }

  get isConnectAllowed() {
    let admin = JSON.parse(session.get() || '');
    return 'ADMIN' === admin.profile || admin.type === true;
  }

  public onRefreshSmart(smart: any) {
    let payload = {
      _idRegion: this._idRegion,
      _idSite: this._idSite,
    };
    this.syncSmart(smart._id).then(() => {
      clearInterval(this.interval);
      this.interval = setInterval(() => {
        this.getSmart(payload);
      }, 30000);
      this.getSmart(payload);
    });
  }

  public onGetSmart(smartConnect: any) {
    let admin = JSON.parse(session.get() || '');
    if ('ADMIN' !== admin.profile && admin.type !== true) return;
    if (!smartConnect.isConnected) {
      this.onRefreshSmart(smartConnect);
      return;
    }
    if (smartConnect.adConnectDevice && smartConnect.adConnectDevice.expose) {
      let protocol: string = '';
      protocol = smartConnect.adConnectDevice.expose.find(
        (expose: String) => expose === 'https',
      );
      if (protocol !== 'https') {
        protocol = smartConnect.adConnectDevice.expose.find(
          (expose: String) => expose === 'http',
        );
      }
      let connect: any = {
        protocol: protocol,
        mac: smartConnect.mac,
      };
      this.onSmart(connect);
    } else {
      this.alert({
        prefix: 'CONNECT_',
        error: 'NOT',
      });
    }
  }
}
